import { render, staticRenderFns } from "./partinstall.vue?vue&type=template&id=0d0a05e8&scoped=true&"
import script from "./partinstall.vue?vue&type=script&lang=js&"
export * from "./partinstall.vue?vue&type=script&lang=js&"
import style0 from "./partinstall.vue?vue&type=style&index=0&id=0d0a05e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0a05e8",
  null
  
)

export default component.exports